import { Component, OnInit, Input, OnChanges, SimpleChanges, ElementRef, ViewChild, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { SupervisionError } from 'solar-bo';



@Component({
  selector: 'app-issuerelevance',
  templateUrl: './issuerelevance.component.html',
  styleUrls: ['./issuerelevance.component.scss']
})
export class IssueRelevanceComponent implements OnInit, OnChanges, AfterViewInit {

  _issue:SupervisionError;
  @Input() set issue(value:SupervisionError){
    this._issue=value;
    this.configComponent();
  }
  get issue():SupervisionError{
    return this._issue;
  }
  @Input()showDesc=true;
  relevanceDesc: string = "";
  relevancecolorclass: string = "";

  constructor() { }

  ngOnInit() {
    if (this.issue) {

    }
  }

  ngOnChanges(changes: SimpleChanges) {

  }

  ngAfterViewInit() {

  }

  ui_relevance(issue) {
    if (!issue) {
      return "";
    }

    if (issue.info) {
      let rel = issue.info.relevance;
      this.configData(rel);
      return rel;
    }
  }

  configComponent(){
    if (!this._issue) {
      this.relevanceDesc="";
      this.relevancecolorclass="";
    }
    if (this._issue.info) {
      let rel = this._issue.info.relevance;
      this.relevanceDesc=rel;
      this.configData(rel);
      return rel;
    }
  }

  private configData(relevance: string) {
    let rel = relevance.toUpperCase();
    switch (rel) {
      case "VERYLOW":
        this.relevanceDesc="Very Low";
        this.relevancecolorclass = "relevance-verylow";
        break;        
      case "LOW":
        this.relevanceDesc="Low";
        this.relevancecolorclass = "relevance-low";
        break;
      case "MED":
        this.relevanceDesc="Medium";
        this.relevancecolorclass = "relevance-med";
        break;        
      case "HIGH":
        this.relevanceDesc="High";
        this.relevancecolorclass = "relevance-high";
        break;
      case "VERYHIGH":
        this.relevanceDesc="Very High";
        this.relevancecolorclass = "relevance-veryhigh";
        break;        
      default:
        this.relevanceDesc="Unknown";
        this.relevancecolorclass = "relevance-veryhigh";      
    }
  }
}
